var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center py-20"},[_c('p',{staticClass:"text-gray-500 text-lg"},[_vm._v("No items found for \""+_vm._s(_vm.searchQuery)+"\"")]),_c('button',{staticClass:"mt-4 text-primary-600 font-bold hover:underline",on:{"click":_vm.clearSearch}},[_vm._v(" Clear Search ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }